import styled from "styled-components";

export const RootContainer = styled.div`
	position: relative;
	margin: 0;
	background-color: #ffffff;
`;

export const Heading = styled.div`
	display: flex;
	justify-content: center;
  align-items: center;
  width: 100%;
  background-color: #DEEDFF;
  padding: 16px 0;
  gap: 4px;
`;


export const Title = styled.p`
	color: #000000;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 25px; 
	text-align: center;
`;

export const NumOfFriend = styled.p`
  color: #004F9C;
  font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 25px; 
	text-align: center;
`

export const SpinWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: 10px;
`;

export const NoFriendWrapper = styled.div`
	height: 70vh;
	width: calc(100% - 32px);
	margin: 16px auto;
	border-radius: 16px !important;
  border: 1px solid #DEEDFF;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 16px;
	overflow-y: hidden;
`;

export const FriendListContiner = styled.div`
  min-height: calc(100vh - 70px - 30px - 16px - 16px - 100px);
  margin-top: 16px;
  border-radius: 16px;
  border: 1px solid #DEEDFF;
  background:  #FFF;
`;

export const OuterDiv = styled.div`
	border-bottom: 1px solid #DEEDFF;
	display: flex;
	justify-content: space-between;
	padding: 16px;
`;

export const InfoText = styled.span`
	color: ${(props) => (props.isName === true ? "#000000" : "#535353")};
	font-size: ${(props) => (props.isName === true ? "16px" : "14px")};
	line-height: 16px;
	font-weight: 500;
`;

export const FriendInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`;

export const Number = styled.div`
	font-size: 16px;
	font-weight: 500;
	color: #000000;
`;

export const LeftSection = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 8px;
`;

export const DateText = styled.div`
	color: #004F9C;
	font-weight: 500;
	font-size: 16px;
`;

export const InviteText = styled.p`
	color: #000000;
	font-weight: 400;
	font-size: 14px;
`;
